import React from 'react';
import { Magnet, Gamepad2, Flame } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function MechanismReveal() {
  return <section className="py-14 px-6 relative overflow-hidden bg-[#0a0a0a]" data-id="element-169">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-rose/5 rounded-full blur-[100px] pointer-events-none" data-id="element-170" />

      <div className="max-w-4xl mx-auto" data-id="element-171">
        <FadeIn data-id="element-172">
          <div className="text-center mb-12" data-id="element-173">
            <span className="text-brand-rose font-medium tracking-wider uppercase text-sm mb-3 block" data-id="element-174">
              La Verdad Oculta
            </span>
            <h2 className="font-serif text-4xl md:text-6xl font-bold leading-tight mb-6" data-id="element-175">
              No estás fallando tú… <br data-id="element-176" />
              <span className="text-brand-lightGray italic" data-id="element-177">
                estás fallando la estrategia.
              </span>
            </h2>
            <div className="space-y-4 text-lg text-brand-lightGray max-w-2xl mx-auto" data-id="element-178">
              <p data-id="element-179">
                La mayoría cree que el problema es:{' '}
                <strong className="text-brand-cream font-medium" data-id="element-180">
                  "No soy lo suficientemente interesante"
                </strong>
                .
              </p>
              <p data-id="element-181">
                Pero la realidad es otra: El problema es que no sabes activar
                los disparadores psicológicos correctos en el momento correcto.
              </p>
              <p className="text-brand-rose font-medium text-xl" data-id="element-182">
                Los hombres no responden por lógica… responden por emoción,
                curiosidad y estímulo.
              </p>
            </div>
          </div>
        </FadeIn>

        <div className="space-y-5" data-id="element-183">
          <FadeIn delay={0.1} direction="left" data-id="element-184">
            <div className="flex flex-col md:flex-row gap-5 items-start md:items-center p-6 rounded-2xl bg-gradient-to-r from-brand-gray/40 to-transparent border-l-4 border-brand-rose" data-id="element-185">
              <div className="p-3 bg-brand-dark rounded-full shadow-lg border border-white/5" data-id="element-186">
                <Magnet className="w-7 h-7 text-brand-rose" data-id="element-187" />
              </div>
              <div data-id="element-188">
                <h3 className="text-xl font-serif font-bold mb-1" data-id="element-189">
                  El imán invisible
                </h3>
                <p className="text-brand-lightGray text-sm" data-id="element-190">
                  Tu forma de escribir puede ser como un imán… o como plástico.
                  El imán atrae sin esfuerzo. El plástico no mueve nada.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} direction="right" data-id="element-191">
            <div className="flex flex-col md:flex-row gap-5 items-start md:items-center p-6 rounded-2xl bg-gradient-to-l from-brand-gray/40 to-transparent border-r-4 border-brand-rose md:text-right md:flex-row-reverse" data-id="element-192">
              <div className="p-3 bg-brand-dark rounded-full shadow-lg border border-white/5" data-id="element-193">
                <Gamepad2 className="w-7 h-7 text-brand-rose" data-id="element-194" />
              </div>
              <div data-id="element-195">
                <h3 className="text-xl font-serif font-bold mb-1" data-id="element-196">
                  El control remoto emocional
                </h3>
                <p className="text-brand-lightGray text-sm" data-id="element-197">
                  Cada mensaje correcto es como presionar un botón: curiosidad,
                  deseo, intriga… o indiferencia.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} direction="left" data-id="element-198">
            <div className="flex flex-col md:flex-row gap-5 items-start md:items-center p-6 rounded-2xl bg-gradient-to-r from-brand-gray/40 to-transparent border-l-4 border-brand-rose" data-id="element-199">
              <div className="p-3 bg-brand-dark rounded-full shadow-lg border border-white/5" data-id="element-200">
                <Flame className="w-7 h-7 text-brand-rose" data-id="element-201" />
              </div>
              <div data-id="element-202">
                <h3 className="text-xl font-serif font-bold mb-1" data-id="element-203">
                  La conversación como fuego
                </h3>
                <p className="text-brand-lightGray text-sm" data-id="element-204">
                  Si no sabes alimentarlo… se apaga. Pero si sabes cómo hacerlo…
                  crece solo.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}